import { useQuery } from '@tanstack/react-query'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { BulkAssignScreen } from '@/features/payroll-bulk-assign/bulk-assign-screen'
import { hasGrant, meQuery } from '@/lib/me'

export interface BulkAssignSearch {
  component?: string
  operation?: string
}

export const Route = createFileRoute('/_authenticated/payroll/bulk-assign')({
  validateSearch: (search: Record<string, unknown>): BulkAssignSearch => ({
    component:
      typeof search.component === 'string' && search.component ? search.component : undefined,
    operation:
      typeof search.operation === 'string' && search.operation ? search.operation : undefined,
  }),
  beforeLoad: ({ context, search }) => {
    if (!hasGrant(context.queryClient, 'payroll_component.edit')) {
      throw redirect({ to: '/payroll/runs' })
    }
    if (!search.operation && !search.component) {
      throw redirect({ to: '/payroll/components' })
    }
  },
  component: BulkAssignRoute,
})

function BulkAssignRoute() {
  const { data: me } = useQuery(meQuery)
  const search = Route.useSearch()
  const companyId = me?.active_company_id
  return companyId ? (
    <BulkAssignScreen
      companyId={companyId}
      initialComponentId={search.component}
      initialOperation={search.operation}
    />
  ) : null
}
